import { useContext, useState, useEffect, useRef } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { logoutURL } from '../../constants/urls'
import {
  publicacionesVencidas,
  tiendaOficialVencimiento
} from '../../helpers/notificarVencimientos.js'
import { CarritoContext } from '../context/carritoContext'
import { LoginContext } from '../context/loginContext'
import { MenuContext } from '../context/menuContext'
import ImagenPerfil from '../imagen/ImagenPerfil'
import MenuFavoritos from '../MenuFavoritos'
import { buscarTodasOptimizado } from '../servicios/publicacionesService'
import { buscarPorUsuario } from '../servicios/tiendasOficialesService.js'
import LinkButton from '../ui/LinkButton'
import styles from './Cabecera.module.css'
import CabeceraBuscador from './CabeceraBuscador'
import DropdownNotificacion from './DropdownNotificacion'

const TIMEOUT_REVOKE_TOKEN = 30000

const Cabecera = () => {
  const { desplegarMenu, menuAbierto } = useContext(MenuContext)
  const { cantidad, setVerCarrito } = useContext(CarritoContext)
  const { loginDataContext, logout, renewToken } = useContext(LoginContext)
  const [showAviso, setShowAviso] = useState(false)
  const [refreshNotificaciones, setRefreshNotificaciones] = useState(false)
  const timeRevoke = useRef()
  const time = useRef()

  const handleRevokeToken = () => {
    logout()
    setShowAviso(false)
    window.location.href = logoutURL
  }

  const handleRefreshToken = () => {
    renewToken()
    clearTimeout(timeRevoke.current)
    avisoSesionEstado()
    setShowAviso(false)
  }

  const showSessionWarning = () => {
    if (localStorage.getItem('refreshjwt') !== null) {
      setShowAviso(true)
      timeRevoke.current = setTimeout(() => {
        handleRevokeToken()
      }, TIMEOUT_REVOKE_TOKEN)
      return () => clearTimeout(timeRevoke.current)
    }
  }

  const avisoSesionEstado = () => {
    time.current = setTimeout(
      () => {
        showSessionWarning()
        return () => clearTimeout(time.current)
      },
      import.meta.env.VITE_EXPIRATION_TIME
    )
  }

  const resetTimer = () => {
    clearTimeout(time.current)
    avisoSesionEstado()
  }

  useEffect(() => {
    avisoSesionEstado()
    window.addEventListener('click', () => resetTimer())
    window.addEventListener('keypress', () => resetTimer())
  }, [])

  const fetchData = async (idUsuario) => {
    const { data: publicaciones } = await buscarTodasOptimizado(0, idUsuario, 0, '')
    const { data: tienda } = await buscarPorUsuario(idUsuario)
    let notificaTienda = false
    let notificaPublicacion = false

    if (tienda) {
      notificaTienda = await tiendaOficialVencimiento(tienda, idUsuario, publicaciones)
    }

    if (publicaciones.length > 0) {
      notificaPublicacion = await publicacionesVencidas(publicaciones, idUsuario)
    }
    if (notificaPublicacion || notificaTienda) {
      setRefreshNotificaciones(true)
    }
  }

  useEffect(() => {
    if (loginDataContext.idUsuario) {
      fetchData(loginDataContext.idUsuario)
    }
  }, [loginDataContext.idUsuario])

  return (
    <>
      {/* Main header row with 3 columns */}
      <div className={styles.cabecera_row}>
        {/* Column 1: Logo on top, Menu + Profile below */}
        <div className={styles.col_lateral}>
          {/* First div: Logo */}
          <div className={styles.col_logo}>
            <div className="d-none d-lg-block">
              <Link className={styles.ebmLogo} onClick={handleRevokeToken}>
                e-buymarket<span className={styles.com}>.com</span>
              </Link>
            </div>
          </div>

          {/* Second div: Menu + Profile */}
          <div className={styles.col_menu_perfil}>
            {/* Menu - always visible */}
            <label
              className={`icon-menu ${styles.label_menu}`}
              htmlFor="menu-bar"
              data-bs-toggle="collapse"
              onClick={() => desplegarMenu(!menuAbierto)}
            >
              <i className={`fa ${menuAbierto ? 'fa-times' : 'fa-bars'}`} aria-hidden="true" />
            </label>

            {/* Profile Image and Name */}
            {localStorage.getItem('empid') && localStorage.getItem('idUsuario') && (
              <div className={styles.perfil_contenedor}>
                {/* Profile Image - centered and bigger */}
                <Link to="/Perfil">
                  <div className={styles.cont_perfil_img}>
                    <ImagenPerfil
                      idUsuario={parseInt(localStorage.getItem('idUsuario'))}
                      clase={styles.perfil_img}
                    />
                  </div>
                </Link>

                {/* Profile Name - centered horizontally, bottom vertically */}
                <div className={`cont-perfil ${styles.cont_perfil_nombre}`}>
                  <Link className={styles.perfil} to="/Perfil">
                    {loginDataContext.nombre}
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Column 2: Search Bar and MenuFavoritos (grows to fill space) */}
        <div className={styles.col_central}>
          {/* Search Bar */}
          <div id="contenedorPadreSearch" className={styles.search_wrapper}>
            <div
              id="contenedorSearch"
              className="d-flex justify-content-center align-items-center w-100"
            >
              <CabeceraBuscador />
            </div>
          </div>

          {/* Menu Favoritos below search */}
          <div className={styles.barra_acceso_directo}>
            <MenuFavoritos />
          </div>
        </div>

        {/* Column 3: Logout at top, Notifications + Cart at bottom */}
        <div className={styles.col_acciones}>
          {/* Top: Logout Button */}
          <div className={styles.btn_salir_wrapper}>
            <Button variant="danger" onClick={handleRevokeToken}>
              <i className={`fa fa-sign-out ${styles.icon_salir}`} aria-hidden="true" />
              Salir
            </Button>
          </div>

          {/* Bottom: Notifications + Cart - positioned at absolute bottom */}
          <div className={styles.acciones_bottom}>
            {/* Notifications */}
            <div id="esUnificado">
              <DropdownNotificacion refreshKey={refreshNotificaciones} />
            </div>

            {/* Cart */}
            <div id="contenedorNotificacionCarrito">
              <Link
                to={'/Carrito'}
                id="notificacion-carrito"
                className="btn btn-notificaciones"
                onClick={() => setVerCarrito(false)}
              >
                <i className="fa fa-shopping-cart" aria-hidden="true" />
                <span className="badge badge-light">{cantidad}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}

      <Modal
        show={showAviso}
        onHide={handleRevokeToken}
        backdrop={'static'}
        className="w-25 ml-auto mr-auto"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Psst!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col">
              ¿Sigues ahí?..
              <br />
              Si no confirmas, tu sesión finalizará.
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <LinkButton className="btn btn-danger" to="/login/" onClick={() => handleRevokeToken()}>
            Cerrar Sesión
          </LinkButton>
          <LinkButton className="btn btn-comprar" onClick={() => handleRefreshToken()}>
            ¡Aún sigo aquí!
          </LinkButton>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Cabecera
